import {  APIData } from '../../constants';
import useRest from './useRest';

const preffix = "auth";


export const useEmail = (options?:APIData) => {
  return useRest(`${preffix}/email`, options);
};

export const useOtp = (options?:APIData) => {
  return useRest(`${preffix}/otp`, options);
};

export const useAuth = (options?:APIData) => {
  return useRest(`${preffix}/`, options);
};